"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyleIconButton = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5)
    }
  };
});
var EditableTabLabel = function EditableTabLabel(props) {
  var title = props.title,
    handleEdit = props.handleEdit,
    index = props.index,
    _props$small = props.small,
    small = _props$small === void 0 ? false : _props$small;
  var classes = useStyleIconButton();
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disableRipple: true,
    size: "small",
    onClick: function onClick(event) {
      event.stopPropagation();
      handleEdit(title, index);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Edit["default"], {
    className: "".concat(small ? classes.icon : '')
  }));
};
var _default = EditableTabLabel;
exports["default"] = _default;